import React from 'react';
import PropTypes from 'prop-types';
import PDPValuePropsModalUI from './PDPValuePropsModalUI';

const PDPValuePropsModal = ({ itemId }) => <PDPValuePropsModalUI itemId={itemId} />;

PDPValuePropsModal.propTypes = {
  itemId: PropTypes.string,
};

export default PDPValuePropsModal;
